import refs from '../helpers/refs'

class CBlockFaq {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    const links = document.querySelector('#c-faq-links ul')

    if (links) {
      const link = document.createElement('li')
      const text = this.$refs.header.dataset.heading
      const anchor = this.$refs.header.dataset.anchor

      const classLink = links.dataset.classLink || 'c-faq-links__anchor-link block md:hover:underline p-2 pt-3 md:pt-0 mb-2 md:mb-0'
      const classSpan = links.dataset.classSpan || 'c-faq-links__anchor-link-border block border-b-4 md:border-b-0 border-transparent text-grey-500 font-bold whitespace-nowrap md:whitespace-normal uppercase text-body-1'

      link.innerHTML = `
        <a class="${classLink}" href="#${anchor}">
          <span class="${classSpan}">
            ${text}
          </span>
        </a>`

      links.appendChild(link)
    }

    // On dropdown click, close other dropdowns (from other c-block-faqs)
    const blockDropdowns = this.$root.querySelectorAll('.c-block-faq__checkbox')
    const allDropdowns = document.querySelectorAll('.c-block-faq__checkbox')

    if (blockDropdowns) {
      blockDropdowns.forEach((activeDropdown) => {
        activeDropdown.addEventListener('change', () => {
          allDropdowns.forEach((dropdown) => {
            if (dropdown !== activeDropdown) {
              dropdown.checked = false
            }
          })
        })
      })
    }

    // Load manuals and other documents
    this.getDocuments()
  }

  buildLinks (heading, documents) {
    let docsList = `<h3>${heading}</h3><ul class="pb-6">`
    documents.forEach((document) => {
      docsList += `<li class="pb-1"><a href="${document.file_url}" target="_blank">${document.title} (PDF)</li>`
    })
    docsList += '</ul>'
    return docsList
  }

  async getDocuments () {
    // add &locale=en_US or en_GB or fr or de or fr or es or se or sv to add locale specific manuals
    let url = `https://3mxotm9s45.execute-api.us-west-2.amazonaws.com/Prod/manuals?sku=${this.$refs.manualSku.dataset.modelno}`
    // add &locale=en or fr or de or fr or es or se or sv to add locale specific manuals
    if (window.localeInformation.language !== '') {
      url += `&locale=${window.localeInformation.language}`
    }

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`)
      }

      const json = await response.json()
      const manuals = json.message.items.filter(
        element => element.type === 'Manual'
      )
      const warnings = json.message.items.filter(
        element => element.type === 'Warning'
      )
      const additionalDocuments = json.message.items.filter(
        element => element.type === 'Additional Document'
      )
      /*
      console.log(
        'manuals',
        manuals.length,
        'warnings',
        warnings.length,
        'additional documents',
        additionalDocuments.length
      )
      */
      // console.log(json)
      // Once you get the items, format them into HTML and drop them in the manuals div
      if (manuals.length > 0) {
        const manualsString = this.buildLinks(window.manualSearchStrings.manuals, manuals)
        document.querySelector('#manuals').innerHTML = manualsString
      }
      if (warnings.length > 0) {
        const warningsString = this.buildLinks(window.manualSearchStrings.warnings, warnings)
        document.querySelector('#warnings').innerHTML = warningsString
      }
      if (additionalDocuments.length > 0) {
        const additionalString = this.buildLinks(window.manualSearchStrings.additional_documents, additionalDocuments)
        document.querySelector('#additional-documents').innerHTML = additionalString
      }
    } catch (error) {
      console.error(error.message)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-block-faq')
    .forEach(el => new CBlockFaq(el))
})
